// v2 endpoints
export const GET_APPLICATIONS = 'providers/AccessManagementApplication/GET_APPLICATION';
export const CREATE_APPLICATION = 'providers/AccessManagementApplication/CREATE_APPLICATION';
export const UPDATE_APPLICATION = 'providers/AccessManagementApplication/UPDATE_APPLICATION';
export const DELETE_APPLICATION = 'providers/AccessManagementApplication/DELETE_APPLICATION';
export const GET_USERS_BY_ROLE = 'providers/AccessManagementApplication/GET_USERS_BY_ROLE';
export const GET_APPLICATION_ROLES = 'providers/AccessManagementApplication/GET_APPLICATION_ROLES';
export const GET_APPLICATION_PERMISSIONS = 'providers/AccessManagementApplication/GET_APPLICATION_PERMISSIONS';

// UI state
export const SELECTED_APPLICATION = 'providers/AccessManagementApplication/SELECTED_APPLICATION';
